import { useState } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import {
  useGetAssemblyForEvaluationQuery,
  useStructureDefectLegendsQuery,
  DefectLegend,
} from '@/__generated__/graphql';

export const useAssemblyData = (params?: { assemblyId?: string }) => {
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);

  const structureId = useGetStructureId();
  const [assemblyDetails, setAssemblyDetails] = useState<Record<string, string>>();
  const [assemblyArea, setAssemblyArea] = useState<number>(0);
  const [defectLegends, setDefectsLegends] = useState<DefectLegend[]>();

  useStructureDefectLegendsQuery({
    variables: { structureId },
    onCompleted: (data) => {
      setDefectsLegends(data?.structure?.defectLegends || []);
    },
  });

  const { loading: assemblyDataLoading } = useGetAssemblyForEvaluationQuery({
    variables: { assemblyId: params?.assemblyId || selectedAssemblyId },
    onCompleted: (data) => {
      if (data?.assembly?.templateFieldData) {
        setAssemblyDetails(data?.assembly.templateFieldData);
        setAssemblyArea(data?.assembly.area ?? 0);
      }
    },
  });

  return {
    assemblyDetails,
    assemblyArea,
    defectLegends,
    assemblyDataLoading,
  };
};
